import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogFooter,
} from '@/components/ui/dialog';
import { DialogHero } from '@/components/ui/dialog-hero';

function fmt(secs: number) {
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

interface Props {
  open: boolean;
  secondsLeft: number;
  onContinue: () => void;
  onLogout: () => void;
}

export function IdleWarningDialog({ open, secondsLeft, onContinue, onLogout }: Props) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onContinue(); }}>
      <DialogContent className="sm:max-w-sm" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHero
          icon={Clock}
          title={t('idle.warningTitle')}
          subtitle={t('idle.warningMessage', { time: fmt(Math.max(secondsLeft, 0)) })}
        />

        <div className="flex justify-center py-2">
          <span className="text-4xl font-mono font-bold tabular-nums text-yellow-600">
            {fmt(Math.max(secondsLeft, 0))}
          </span>
        </div>

        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={onLogout}>{t('idle.logoutNow')}</Button>
          <Button onClick={onContinue}>{t('idle.continue')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
